import {
  Box,
  Button,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { RiSearchLine } from 'react-icons/ri'
import { RawMaterial } from '../../../../../Interfaces/rawMaterial'

interface RawMaterialSelectionModalProps {
  isOpen: boolean
  onClose: () => void
  onSelect: (rawMaterial: RawMaterial) => void
  rawMaterials: RawMaterial[]
}

export function RawMaterialSelectionModal({
  isOpen,
  onClose,
  onSelect,
  rawMaterials,
}: RawMaterialSelectionModalProps) {
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    if (isOpen) {
      setSearchTerm('')
    }
  }, [isOpen])

  const filteredRawMaterials = rawMaterials.filter((material) =>
    material.name.toLowerCase().includes(searchTerm.toLowerCase())
  )

  const handleSelectMaterial = (material: RawMaterial) => {
    onSelect(material)
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay />
      <ModalContent bg="gray.800" color="white" {...({} as any)}>
        <ModalHeader>
          <Text fontSize="lg" fontWeight="bold">
            Selecionar Matéria-Prima
          </Text>
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <VStack spacing={4} align="stretch">
            {/* Campo de busca */}
            <Box>
              <Text mb={2}>
                Buscar matéria-prima
              </Text>
              <Input
                placeholder="Digite o nome da matéria-prima..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                bg="gray.700"
                color="white"
                borderColor="gray.600"
                _hover={{ borderColor: 'pink.400' }}
                _focus={{ borderColor: 'pink.400', boxShadow: 'none' }}
                leftIcon={<RiSearchLine />}
                {...({} as any)}
              />
            </Box>

            {/* Lista de matérias-primas */}
            <Box maxHeight="400px" overflowY="auto">
              <VStack spacing={0} align="stretch">
                {filteredRawMaterials.length === 0 ? (
                  <Text color="gray.400" textAlign="center" py={4}>
                    {searchTerm ? 'Nenhuma matéria-prima encontrada' : 'Nenhuma matéria-prima disponível'}
                  </Text>
                ) : (
                  filteredRawMaterials.map((material) => (
                    <HStack
                      key={material.id}
                      p={3}
                      _hover={{ bg: 'gray.600' }}
                      cursor="pointer"
                      onClick={() => handleSelectMaterial(material)}
                      borderRadius="md"
                      {...({} as any)}>
                      <Box flex={1}>
                        <Text color="white" fontSize="sm" fontWeight="medium">
                          {material.name}
                        </Text>
                        <Text color="gray.400" fontSize="xs">
                          {material.amount} {material.measurement_unit} - R$ {material.price.toFixed(2)}
                        </Text>
                      </Box>
                    </HStack>
                  ))
                )}
              </VStack>
            </Box>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" onClick={onClose} flex={1}>
            Cancelar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
